import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HistoryStore, TimeBucketUnits } from '@iotv/datamodel';
import { FEATURE_ON_OFF } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useBucketing } from '../../../hooks/useBucketing';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const BucketingWidget = () => {
    const [store] = useState(new HistoryStore());
    const { components } = useBucketing({
        historyStore: store,
        bucketingOnOff: FEATURE_ON_OFF.ON,
        timeBucketDef: {
            unit: TimeBucketUnits.MINUTE,
            width: 15,
        },
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "OnOff" }), _jsx(Stack, { direction: "row", children: components.OnOff }), _jsx(Typography, { variant: "h5", children: "bucketUnit" }), components.bucketUnit, _jsx(Typography, { variant: "h5", children: "bucketWidth" }), components.bucketWidth] })), [components]);
    return {
        name: 'useBucketing',
        category: 'hooks',
        component,
    };
};
